export default __webpack_public_path__ + "static/media/082.863bd1f5.jpg";